// Dark mode desativado temporariamente até o designer finalizar o novo tema.
// Para reativar: restaurar leitura de localStorage/profiles.theme em getInitialTheme,
// e a lógica de toggleTheme que persiste a preferência. A coluna profiles.theme
// continua existindo no banco e preserva a preferência prévia de cada usuário.

type Theme = 'light';
const THEME_STORAGE_KEY = 'midhaus-theme';

export const getInitialTheme = (): Theme => 'light';

export const applyThemeToDOM = (_theme: Theme) => {
  if (typeof window === 'undefined') return;
  const root = document.documentElement;
  root.classList.remove('dark');
  root.classList.add('light');
  try {
    localStorage.setItem(THEME_STORAGE_KEY, 'light');
  } catch {
    // ignore storage errors
  }
};

export const useTheme = () => {
  return {
    theme: 'light' as Theme,
    toggleTheme: () => {},
    isDark: false,
    isLight: true,
    isLoading: false,
  };
};
